<div class="app-loading">
  <div class="app-loading-card" *ngIf="!error">
    <mat-spinner diameter="48"></mat-spinner>
    <h1>Setting up your workspace</h1>
    <p class="subtitle">One moment while we load your applications…</p>
  </div>

  <div class="app-loading-card" *ngIf="error">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <h1>Something went wrong</h1>
    <p class="subtitle">{{ error }}</p>
    <button mat-raised-button color="primary" (click)="retry()">Try again</button>
  </div>
</div>
